/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import * as router from 'store/ducks/router';

export function useHistoryWithState() {
  const dispatch = useDispatch();
  const history = useHistory();

  const push = React.useCallback(
    (nextLocation: string, state?: unknown, hash?: string) => {
      dispatch(router.ActionCreators.setState(nextLocation, state));
      if (!hash) {
        history.push(nextLocation);
        return;
      }

      history.push({ pathname: nextLocation, hash });
    },
    [dispatch, history]
  );

  const replace = React.useCallback(
    (nextLocation: string, state?: unknown, hash?: string) => {
      dispatch(router.ActionCreators.setState(nextLocation, state));
      if (!hash) {
        history.replace(nextLocation);
        return;
      }

      history.replace({ pathname: nextLocation, hash });
    },
    [dispatch, history]
  );

  return React.useMemo(() => {
    return { push, replace, go: history.go, goBack: history.goBack };
  }, [push, replace, history.go, history.goBack]);
}
